import { Button, Text, VSpacer } from '@/components/DesignSystem';
import { stringifyCount } from "@/constants/HierarchyOfRetailers";
import { QueryKeys } from '@/constants/QueryKeys';
import { useUserList } from '@/hooks/useUserList';
import {
  AddRecipientsModal,
} from '@/pages/Admin/HierarchyOfRetailers/Recipients/AddRecipientsModal';
import { RetailerRecipientApi } from '@/utilities/api/RetailerReceipientApi';
import { Stack, useTheme } from '@mui/material';
import { UserType } from '@shared/enums';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { SharedConfig } from "@shared/SharedConfig";

interface AddRecipientsSectionProps {
  retailerId: string,
}

export const AddRecipientsSection = ({
  retailerId,
}: AddRecipientsSectionProps) => {
  const theme = useTheme();
  const [showAddRecipientsModal, setShowAddRecipientsModal] = useState(false);

  const { users: retailerAdmins } = useUserList({
    limit: SharedConfig.maxPageLimit,
    retailerId,
    userType: [UserType.RetailerAdmin],
  });
  const { data: recipients } = useQuery(
    [QueryKeys.LIST_RETAILER_RECIPIENTS, retailerId],
    () => RetailerRecipientApi.list(retailerId),
  );

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: '12px 20px',
      }}
    >
      <Stack>
        <Text category="title-small">Admin Email Recipients</Text>
        <VSpacer size="1" />
        <Text category="body-medium" sx={{ color: theme.palette.text.secondary }}>
          {stringifyCount(recipients?.length, 'recipient', 'recipients')}
        </Text>
      </Stack>
      <Button
        disabled={!retailerAdmins?.data.length}
        onClick={() => setShowAddRecipientsModal(true)}
        testID="manage-recipients-button"
        variant="outlined"
      >
        Manage Recipients
      </Button>
      {showAddRecipientsModal && retailerAdmins && (
        <AddRecipientsModal
          addedRecipients={recipients ?? []}
          onClose={() => setShowAddRecipientsModal(false)}
          retailerAdminUsers={retailerAdmins.data}
          retailerId={retailerId}
        />
      )}
    </Stack>
  );
};
